import React from 'react';
import '../styles/TrainStrip.css';

const TrainStrip = () => (
  <div className="train-strip">
    🚆 Hii I am Arka Goswami this website is made by me i am interesting in learning new technology and done  | AI Projects | IoT Systems | Web Dev | Embedded | ReactJS | ML | CV | Resume | Projects | 🚀 New Projects Coming Soon!
  </div>
);

export default TrainStrip;
